import pendingPromise from 'utils/pendingPromise';

const cache = new Map();

let DATA_DOMAIN = __IS_LOCAL__ || __IS_DEMO__ ? 'https://hubsite.dev.cmspow.com' : typeof window !== 'undefined' ? location.origin : 'https://www.universalpictures.com';
let CMS_DOMAIN =
	__IS_LOCAL__ || __IS_DEMO__
		? 'https://api.cms.dev.cmspow.com'
		: typeof window !== 'undefined' && location.host === 'stage.universalpictures.com'
			? 'https://stage.api.cms.universalpictures.com/'
			: 'https://api.cms.universalpictures.com';

const qs = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
export const previewMode = qs.has('cms-preview');

let previewDataWaitlist = {};
async function waitForPreviewData(name) {
	let promise = pendingPromise();
	previewDataWaitlist[name] ||= [];
	previewDataWaitlist[name].push(promise);
	return promise;
}

if (previewMode) {
	// const allowedOrigins = ['http://localhost:4010', 'https://demo.pow.io'];
	window.addEventListener('message', e => {
		// if (!allowedOrigins.includes(e.origin)) return;
		let message = e.data;
		if (message?.type === 'data' && previewDataWaitlist[message.name]) {
			previewDataWaitlist[message.name].forEach(p => p.resolve(message.data));
			previewDataWaitlist[message.name] = [];
		}
	}, false);
}

async function getDataRaw(name, type = 'section') {
	// simulate slowness
	// await new Promise(resolve => setTimeout(resolve, 1000));

	if (previewMode && window.parent !== window) {
		window.parent.postMessage({ type: 'requestData', name }, '*');
		let data = await waitForPreviewData(name);
		if (data !== null) return data;
	}

	try {
		// if (qs.has('static')) throw new Error('Using mocks');
		const res = await fetch(new URL(`cms/${type}s/${name}.json`, DATA_DOMAIN));
		if (!res.ok) {
			throw new Error(`Data unavailable for ${name}`);
		}
		return await res.json();
	} catch {}

	// Keep mock data for now as fallback
	// if (name === 'navigation') {
	// 	return (await import(/* webpackChunkName: 'navigation-data' */ './tmp/navigation.js')).default;
	// } else if (name === 'about') {
	// 	return (await import(/* webpackChunkName: 'about-data' */ './tmp/about.js')).default;
	// } else if (name === 'landing') {
	// 	return (await import(/* webpackChunkName: 'landing-data' */ './tmp/landing.js')).default;
	// } else if (name === 'movie') {
	// 	return (await import(/* webpackChunkName: 'movie-data' */ './tmp/movie.js')).default;
	// } else if (name === 'releases') {
	// 	return (await import(/* webpackChunkName: 'releases-data' */ './tmp/releases.js')).default;
	// } else if (name === 'news') {
	// 	return (await import(/* webpackChunkName: 'news-data' */ './tmp/news.js')).default;
	// } else if (name === 'leadership') {
	// 	return (await import(/* webpackChunkName: 'leadership-data' */ './tmp/leadership.js')).default;
	// } else if (name === 'region') {
	// 	return (await import(/* webpackChunkName: 'region-data' */ './tmp/region.js')).default;
	// }

	return null;
}

export async function getData(name, type) {
	if (cache.has(name)) {
		return cache.get(name);
	}
	const promise = getDataRaw(name, type === 'movie' ? 'movie' : 'section');
	cache.set(name, promise);
	return promise;
}

export async function cmsRequest(path, qs) {
	// return { data: [{ id: '0a40633b-6556-49c1-b36b-1db9863154dd', thundr_id: 1234 }, { id: '1a40633b-6556-49c1-b36b-1db9863154de' }] };
	const url = new URL(path, CMS_DOMAIN);
	if (qs) {
		url.search = new URLSearchParams(qs).toString();
	}
	const res = await fetch(url);
	if (!res.ok) {
		throw new Error(res.status);
	}
	return await res.json();
}